import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import AllAdmins from './AllAdmins';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, admins, totalPage, currentPage, adminOverview,
  } = state.admin;
  return {
    isLoading,
    admins,
    totalPage,
    currentPage,
    adminOverview,
  };
}

const Styled = withStyles(styles)(AllAdmins);

export default connect(
  mapStateToProps,
)(Styled);
